module.exports = __webpack_public_path__ + "static/media/swap.99bbe941.svg";